import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "physicalGuarantorTemplate",
    "moralGuarantorTemplate",
    "noneGuarantorTemplate",
    "guarantorBloc",
  ]

  connect() {
    this.updateGuarantorOption()
  }

  updateGuarantorOption(e) {
    this.guarantorBlocTarget.innerHTML = ""

    const option = this.element.querySelector("[name='guarantor_option']:checked").value
    if (option == "none") {
      // Aucun garant
      const form = this.noneGuarantorTemplateTarget.content.cloneNode(true);
      this.guarantorBlocTarget.appendChild(form)
    } else {
      if (option == "physical") {
        // Garant Physique
        const form = this.physicalGuarantorTemplateTarget.content.cloneNode(true);
        this.guarantorBlocTarget.appendChild(form)
      } else {
        // Garant Moral
        const form = this.moralGuarantorTemplateTarget.content.cloneNode(true);
        this.guarantorBlocTarget.appendChild(form)
      }
    }
  }

  createElementFromHTML(htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  }
}
